import dynamic from "next/dynamic";

export const DynamicContent008 = dynamic(() => import("./Content008"), {
  suspense: true,
});
